import { FormattedMessage } from 'react-intl';

import { ISolutionsCardProps } from './solutions-card.models';
import { useStyles } from './solutions-card.styles';
import { SolutionsBrandLogo } from '../../../../../common/solutions-brand-logo';
import { SolutionsBrandType } from '../../../../../../graphql/lenses/models/get-lenses.models';

export const SolutionsCard = ({ cardData }: ISolutionsCardProps): JSX.Element => {
  const classes = useStyles();
  const { brandId, brand: { fullName } } = cardData;

  return (
    <li className={classes.root} data-testid="solutions-card">
      <SolutionsBrandLogo
        className={classes.solutionsBrandLogo}
        brand={brandId as SolutionsBrandType}
      />
      <div>
        <h4 className={classes.brandName}>{fullName}</h4>
        <p className={classes.description}>
          <FormattedMessage id="myLensesDetailed.solutions.description" />
        </p>
      </div>
    </li>
  );
};
